/* External */
import { all } from "redux-saga/effects";

/* Services */
import { backendService } from "../../services";

/* Others */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { makeFetchSaga } from "../../utils";

const fetchStreamsHistorySaga = makeFetchSaga(ACTION_TYPES_BASE_NAME, backendService.experience.getStreamsHistory);

export default function* () {
  yield all([fetchStreamsHistorySaga]);
}
